<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M1.75 5.27776C1.75 3.63577 3.08023 2.30554 4.72222 2.30554H6.75C7.62256 2.30554 8.45024 2.68906 9.01476 3.3531L10.4838 5.08332H15.2778C16.9198 5.08332 18.25 6.41355 18.25 8.05554V14.1667C18.25 15.8086 16.9198 17.1389 15.2778 17.1389H4.72222C3.08023 17.1389 1.75 15.8086 1.75 14.1667V5.27776ZM4.72222 3.80554C3.90866 3.80554 3.25 4.4642 3.25 5.27776V14.1667C3.25 14.9802 3.90866 15.6389 4.72222 15.6389H15.2778C16.0913 15.6389 16.75 14.9802 16.75 14.1667V8.05554C16.75 7.24198 16.0913 6.58332 15.2778 6.58332H10.1367C9.91649 6.58332 9.70744 6.48657 9.56494 6.31873L7.87191 4.32465C7.59199 3.99558 7.18173 3.80554 6.75 3.80554H4.72222Z"
            fill="currentColor"
        />
    </svg>
</template>
